<script setup lang="ts">
import type { Alert } from '../model/alert'
import AlertMessageContent from './alert-message-content.vue'
import AlertReactionContent from './alert-reaction-content.vue'
import AlertReplyContent from './alert-reply-content.vue'

const { alert } = defineProps<{ alert: Alert }>()

const emit = defineEmits<{ 'link-click': [] }>()
</script>

<template>
  <li>
    <AlertMessageContent
      v-if="alert.type === 'message' || alert.type === 'ping' || alert.type === 'NEW_MESSAGE'"
      :alert="alert"
      @link-click="emit('link-click')"
    />

    <AlertReactionContent
      v-if="alert.type === 'reaction' || alert.type === 'NEW_REACTION'"
      :alert="alert"
      @link-click="emit('link-click')"
    />

    <AlertReplyContent v-if="alert.type === 'reply'" :alert="alert" @link-click="emit('link-click')" />
  </li>
</template>
